import { connect } from 'react-redux';
import { Notification } from './Notification';
import styles from './Notifications.module.css';

const NotificationsComponent = ({
    notifications,
}) => {
    return (
        <div className={styles.notificationsWrapper}>
            {
                notifications.map(({ message, type, timeStamp }) => (
                    <Notification
                        key={timeStamp}
                        type={type}
                        timeStamp={timeStamp}
                    >
                        {message}
                    </Notification>
                ))
            }
        </div>);
};
const mapStateToProps = ({ notifications }) => ({ notifications });
export const Notifications = connect(mapStateToProps)(NotificationsComponent);
